<!-- Top bar -->
<mat-toolbar class="topBar" style="justify-content: space-between;">
  <!-- Left Side Content -->
  <div style="display: flex; align-items: center; gap: 20px;">

    <!-- Back to Sets / Delivery -->
    <button mat-mini-fab
            class="example-icon"
            type="button"
            aria-label="Back"
            [matTooltip]="setIndex == -1 || previousScreen == 'delivery' ? 'Back to Delivery' : previousScreen == 'deliveries_list' ? 'Back to Deliveries' :'Back to Home'"
            matTooltipPosition="below"
            (click)="handleExit(setIndex == -1 || previousScreen == 'delivery' ? 'delivery' : previousScreen == 'deliveries_list' ? 'deliveries_list' : 'menu')">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <!-- Back to Home -->
    <button mat-mini-fab
            class="example-icon"
            type="button"
            matTooltip="Back to Home"
            matTooltipPosition="below"
            aria-label="Back to Home"
            (click)="handleExit('menu')">
      <mat-icon>home</mat-icon>
    </button>


  </div>

  <!-- Title -->
  <span *ngIf="setIndex == -1" style="color: white;">Editing Set</span>
  <span *ngIf="setIndex != -1" style="color: white;">Set/Retrieval @if (fishingEvent) { {{fishingEvent.setNumber}}}</span>
  
  <!-- Right Side Buttons -->
  <div style="display: flex; align-items: center; gap: 20px;">
      <!-- Delete Button -->
  <button *ngIf="!isReadOnly"
      mat-mini-fab
      class="blue-icon-button"
      matTooltip="Delete"
      matTooltipPosition="below"
      aria-label="Delete"
      (click)="confirmDelete()">
    <mat-icon>delete</mat-icon>
  </button>

     <!-- Set Errors -->
    <button *ngIf="!isReadOnly"
      mat-mini-fab
      [matBadge]="errorNumber" [matBadgeHidden]="errorNumber == 0" matBadgePosition="above before"
      class="bottom-toolbar-button"
      type="button"
      aria-label="Example icon button with a plus one icon"
      matTooltip="Errors"
      matTooltipPosition="above"
      [disabled]="disableAdd || (setDetailForm.valid && stringNum.valid)"
      (click)="openErrorDialog()">
    <mat-icon>
    priority_high
    </mat-icon>
  </button>
  </div>
</mat-toolbar>



<br>

<!-- The form for all of the input fields -->
<form [formGroup]="setDetailForm">
  <div class="container" style="max-width: none;">
    <div class="row">
      <div class="col">
        <div class="row">
          <mat-form-field style="font-weight: bold;">
            <mat-label>String or Set or Buoy #</mat-label>
            <input matInput [formControl]="stringNum" maxlength="10" oninput="event.target.value = event.target.value.replace(/[^a-zA-Z0-9 ]/gm, '');" required>
          </mat-form-field>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <mat-form-field>
            <mat-label>Gear</mat-label>
            <input matInput readonly formControlName="gear" (click)="addGear()" required>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="!setDetailForm.get('gear')?.value || setDetailForm.get('gear')?.value.type != 'Pelagic'">
      <div class="col">
        <div class="row">
          <mat-form-field>
            <mat-label># of Skates, Tubs, or Pots per set</mat-label>
            <input matInput type="text" inputmode="decimal" formControlName="skateNum" (input)="_forbidNonNumeric(setDetailForm.get('skateNum')!)" required>
          </mat-form-field>
        </div>
      </div>
    </div>

    <br>

    <div class="row">
      <mat-toolbar class="mat-toolbar-section">
        <span>Set Info</span>
        <span class="spacer"></span>

        <!-- Fill set with current time and location -->
        <button *ngIf="!isReadOnly"
                mat-mini-fab
                class="blue-icon-button"
                type="button"
                matTooltip="Fill Set Time and Location"
                matTooltipPosition="below"
                (click)="fillSetTimeLocation()">
          <mat-icon>
            pin_drop
          </mat-icon>
        </button>
      </mat-toolbar>
    </div>

    <div class="row" style="padding-top: 20px;">
      <mat-form-field>
        <mat-label>@if (fishingEvent?.gear?.type == 'Pelagic') {Set} @else {Start} Date and Time</mat-label>
        <input matInput readonly formControlName="startDate" (click)="editDateTime('startDate')" required>
      </mat-form-field>
    </div>

    <div class="row">
      <div class="col">
        <div class="row">
          <mat-form-field>
            <mat-label>@if (fishingEvent?.gear?.type == 'Pelagic') {Set} @else {Start} Latitude</mat-label>
            <input #startLat matInput readonly input="tel" formControlName="startLat" (click)="openCoordinateDialog('startLat')" required>
            <mat-error *ngIf="setDetailForm.get('startLat')?.errors?.shpLatError">Coordinate out of range</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <mat-form-field>
            <mat-label>@if (fishingEvent?.gear?.type == 'Pelagic') {Set} @else {Start} Longitude</mat-label>
            <input #startLon matInput readonly input="tel" formControlName="startLon" (click)="openCoordinateDialog('startLon')" required>
            <mat-error *ngIf="setDetailForm.get('startLon')?.errors?.shpLonError">Coordinate out of range</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="!setDetailForm.get('gear')?.value || setDetailForm.get('gear')?.value.type != 'Pelagic'">
      <div class="col">
        <div class="row">
          <mat-form-field>
            <mat-label>Start Depth (fathoms)</mat-label>
            <input matInput type="text" inputmode="decimal" formControlName="startDepth" oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" required>
            <mat-error *ngIf="setDetailForm.invalid"></mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div *ngIf="fishingEvent?.gear?.type != 'Pelagic'" class="row">
      <div class="col">
        <div class="row">
          <mat-form-field>
            <mat-label>@if (fishingEvent?.gear?.type == 'Pelagic') {Retrieval} @else {End} Latitude</mat-label>
            <input matInput readonly type="tel" formControlName="endLat" (click)="openCoordinateDialog('endLat')" required>
            <mat-error *ngIf="setDetailForm.get('endLat')?.errors?.shpLatError">Coordinate out of range</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <mat-form-field>
            <mat-label>@if (fishingEvent?.gear?.type == 'Pelagic') {Retrieval} @else {End} Longitude</mat-label>
            <input matInput readonly input="tel" formControlName="endLon" (click)="openCoordinateDialog('endLon')" required>
            <!-- Fill haul with current location -->
            <button *ngIf="!isReadOnly"
                    mat-mini-fab
                    matSuffix
                    class="blue-icon-button"
                    style="margin-right: 8px; color: white; background-color: #005d87"
                    type="button"
                    matTooltip="Fill Haul Location"
                    matTooltipPosition="below"
                    (click)="fillHaulTimeLocation()">
              <mat-icon>
                pin_drop
              </mat-icon>
            </button>
            <mat-error *ngIf="setDetailForm.get('endLon')?.errors?.shpLonError">Coordinate out of range</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="setDetailForm.get('gear')?.value && setDetailForm.get('gear')?.value.type == 'Pelagic'">
      <div class="col">
        <div class="row">
          <mat-form-field>
            <mat-label>
              Avg Gear Depth off Bottom (fathoms)
            </mat-label>
            <input matInput type="text" inputmode="decimal" formControlName="depthOffBottom" oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" required>
            <mat-error *ngIf="setDetailForm.invalid"></mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>


    <div class="row" *ngIf="!setDetailForm.get('gear')?.value || setDetailForm.get('gear')?.value.type != 'Pelagic'">
      <div class="col">
        <div class="row">
          <mat-form-field>
            <mat-label>End Depth (fathoms)</mat-label>
            <input matInput type="text" inputmode="decimal" formControlName="endDepth" oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" required>
            <mat-error *ngIf="setDetailForm.invalid"></mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <br>

    <div class="row">
      <mat-toolbar class="mat-toolbar-section">
        <span>Retrieve Info</span>
        <span class="spacer"></span>

        <!-- Fill haul with current time -->
        <button *ngIf="!isReadOnly"
                mat-mini-fab
                class="blue-icon-button"
                type="button"
                aria-label="Example icon-button with share icon"
                [matTooltip]="setDetailForm.get('gear')?.value.type != 'Pelagic' ? 'Fill Haul Time' : 'Fill Haul Time and Location'"
                matTooltipPosition="below"
                (click)="fillHaulTimeLocation(true)">
          <mat-icon>
            pin_drop
          </mat-icon>
        </button>
      </mat-toolbar>
    </div>

    <div class="row" style="padding-top: 20px;">
      <mat-form-field>
        <mat-label>@if (fishingEvent?.gear?.type == 'Pelagic') {Retrieval} @else {End} Date and Time</mat-label>
        <input matInput readonly formControlName="endDate" (click)="editDateTime('endDate')" required>
        <mat-error *ngIf="setDetailForm.get('endDate')?.errors?.setAfterHaul">Haul must be after set</mat-error>
      </mat-form-field>
    </div>

    <div *ngIf="fishingEvent?.gear?.type == 'Pelagic'" class="row">
      <div class="col">
        <div class="row">
          <mat-form-field>
            <mat-label>Retrieval Latitude</mat-label>
            <input matInput readonly type="tel" formControlName="endLat" (click)="openCoordinateDialog('endLat')" required>
            <mat-error *ngIf="setDetailForm.get('endLat')?.errors?.shpLatError">Coordinate out of range</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <mat-form-field>
            <mat-label>Retrieval Longitude</mat-label>
            <input matInput readonly input="tel" formControlName="endLon" (click)="openCoordinateDialog('endLon')">
            <mat-error *ngIf="setDetailForm.get('endLon')?.errors?.shpLonError">Coordinate out of range</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="!setDetailForm.get('gear')?.value || setDetailForm.get('gear')?.value.type != 'Pelagic'">
      <div class="col">
        <div class="row">
          <mat-form-field>
            <mat-label>Lost Skates, Tubs, or Pots Count</mat-label>
            <input matInput type="text" inputmode="decimal" formControlName="lostPotNum" (input)="_forbidNonNumeric(setDetailForm.get('lostPotNum')!)" [errorStateMatcher]="matcher">
            <mat-error *ngIf="setDetailForm.errors?.invalid">Must be less than or equal to skate/tub/pot amount</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Catch -->
    <div class="row">
      <mat-toolbar class="mat-toolbar-section">
        <span>Catch</span>
        <span class="spacer"></span>

        <!-- Add a new catch -->
        <button *ngIf="!isReadOnly"
                mat-mini-fab
                class="blue-icon-button"
                type="button"
                aria-label="Example icon-button with share icon"
                matTooltip="Add New Catch"
                matTooltipPosition="below"
                (click)="openCatchDialog(fishingEvent.catchItems.length)">
          <mat-icon>
            add
          </mat-icon>
        </button>
      </mat-toolbar>
    </div>

    <!-- Catch data -->
    <div *ngIf="fishingEvent" class="row">
      <table mat-table [dataSource]="fishingEvent.catchItems" style="width:100%;">

        <ng-container matColumnDef="Species">
          <tr>
            <th mat-header-cell
                *matHeaderCellDef
                style="text-align: left;">
              Species
            </th>
            <td mat-cell
                *matCellDef="let item">
              {{item.species.name}}
            </td>
          </tr>
        </ng-container>

        <ng-container matColumnDef="RetainedCount">
          <tr>
            <th mat-header-cell
                *matHeaderCellDef
                style="padding-left: 8px;">
              Count
            </th>
            <td mat-cell
                *matCellDef="let item"
                style="text-align: center;">
              {{item.retainedCount}}
            </td>
          </tr>
        </ng-container>

        <ng-container matColumnDef="RetainedWeight">
          <tr>
            <th mat-header-cell
                *matHeaderCellDef
                style="border-right: 1px solid black; padding-left: 8px; padding-right: 8px;">
              Weight
            </th>
            <td mat-cell
                *matCellDef="let item"
                style="text-align: center; border-right: 1px solid black;">
              {{item.retainedWeight}}
            </td>
          </tr>
        </ng-container>

        <ng-container matColumnDef="ReleasedCount">
          <tr>
            <th mat-header-cell
                *matHeaderCellDef
                style="padding-left: 8px;">
              Count
            </th>
            <td mat-cell
                *matCellDef="let item"
                style="text-align: center;">
              {{item.releasedCount}}
            </td>
          </tr>
        </ng-container>

        <ng-container matColumnDef="ReleasedWeight">
          <tr>
            <th mat-header-cell
                *matHeaderCellDef
                style="padding-left: 8px;">
              Weight
            </th>
            <td mat-cell
                *matCellDef="let item"
                style="text-align: center;">
              {{item.releasedWeight}}
            </td>
          </tr>
        </ng-container>

        <ng-container matColumnDef="Filler">
          <tr>
            <th mat-header-cell
                *matHeaderCellDef>

            </th>
          </tr>
        </ng-container>

        <ng-container matColumnDef="Retained">
          <tr>
            <th mat-header-cell
                *matHeaderCellDef
                colspan="2"
                style="border-right: 1px solid black;">
              Retained
            </th>
          </tr>
        </ng-container>

        <ng-container matColumnDef="Released">
          <tr>
            <th mat-header-cell
                *matHeaderCellDef
                colspan="2">
              Released
            </th>
          </tr>
        </ng-container>

        <tr mat-header-row
            *matHeaderRowDef="['Filler', 'Retained', 'Released']"
            class="catch-first-header">
        </tr>

        <tr mat-header-row
            *matHeaderRowDef="catchTableColumns"
            class="catch-second-header">
        </tr>

        <tr mat-row
            (click)="openCatchDialog(index)"
            *matRowDef="let row; columns: catchTableColumns; let index=index;">
        </tr>
      </table>
    </div>

    <div class="row" style="padding-top: 30px;">
      <div class="col">
        <div class="row">
          <mat-form-field>
            <mat-label>Bait Type</mat-label>
            <mat-select formControlName="baitType">
              <mat-option value="Natural">
                Natural
              </mat-option>
              <mat-option value="Artificial">
                Artificial
              </mat-option>
            </mat-select>
            <mat-error *ngIf="setDetailForm.invalid"></mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Comments -->
    <div class="row">
      <mat-toolbar class="mat-toolbar-section">
        <span>Comments</span>
      </mat-toolbar>
    </div>

    <div class="row">
      <mat-form-field appearance="fill">
        <mat-label>Additional Comments</mat-label>
        <textarea matInput rows="9" formControlName="comments"></textarea>
      </mat-form-field>
    </div>

    <br>
    <br>
    <br>
    <br>
    <br>

  </div>
</form>

<!-- Bottom bar -->
<mat-toolbar class="toolbarNav" style="background-color: #004165; padding-left: 10px; padding-right: 10px;">

  <div style="flex-grow: 1; display: flex; justify-content: space-evenly;">
<!-- Go to Previous Set -->
<button *ngIf="!isReadOnly"
mat-fab
class="bottom-toolbar-button"
type="button"
aria-label="Example icon button with a plus one icon"
matTooltip="Previous Set"
matTooltipPosition="above"
[disabled]="setIndex == -1"
(click)="previousSet()">
<mat-icon>
arrow_back
</mat-icon>
</button>

<!-- Add New Set -->
<button *ngIf="!isReadOnly"
mat-fab
class="bottom-toolbar-button"
type="button"
aria-label="Example icon button with a plus one icon"
matTooltip="Add Set"
matTooltipPosition="above"
[disabled]="setIndex == -1"
(click)="addSet()">
<mat-icon>
add
</mat-icon>
</button>

<!-- Go to Next Set -->
<button *ngIf="!isReadOnly"
mat-fab
class="bottom-toolbar-button"
type="button"
aria-label="Example icon button with a plus one icon"
matTooltip="Next Set"
matTooltipPosition="above"
[disabled]="setIndex == -1"
(click)="nextSet()">
<mat-icon>
arrow_forward
</mat-icon>
</button>
  </div>
  
  <button *ngIf="!isReadOnly"
            mat-fab
            class="blue-icon-button"
            matTooltip="Delivery"
            matTooltipPosition="below"
            aria-label="Delivery"
            (click)="handleExit('delivery')">
      <mat-icon>drive_folder_upload</mat-icon>
    </button>

</mat-toolbar>
